import { createAction } from 'redux-actions';
import * as constants from 'constants/redux/conversations';

export const fetchConversationsRequest = createAction(constants.FETCH_CONVERSATIONS_REQUEST);
export const fetchConversationsSuccess = createAction(constants.FETCH_CONVERSATIONS_SUCCESS);
export const fetchConversationsFailure = createAction(constants.FETCH_CONVERSATIONS_FAILURE);

export const clearConversations = createAction(constants.CLEAR_CONVERSATIONS);
export const setConversationsFilter = createAction(constants.SET_CONVERSATIONS_FILTER);
